import { Channel } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore } from '@dinosband/bv-main-client'
import { BvDataCenter } from '@dinosband/bv-data-center'

import { createMessengerVuex } from '../vuex'
import { MessengerContext } from '..'
import { ChatRoomControllerPool } from '../controller-pool'

import { UnreadCountsController } from './unread-counts'
import { MessageFilterController } from './filter'


const _DEBUG_LOG = process.env.NODE_ENV !== 'production' &&
                   !!process.env.VUE_APP_MESSENGER_DEBUG_LOG

export class MessengerStore {

  initialized = false

  context: MessengerContext
  dataCenter: BvDataCenter
  unreadCounts: UnreadCountsController
  controllerPool: ChatRoomControllerPool
  filterController: MessageFilterController

  constructor (dataCenter: BvDataCenter) {
    this.dataCenter = dataCenter
    this.context = dataCenter.context as unknown as MessengerContext
    this.context.messengerStore = this
    this.context.vuexStore = createMessengerVuex()
    this.controllerPool = new ChatRoomControllerPool(this.context, this.dataCenter)
    this.unreadCounts = new UnreadCountsController(this.context, this.dataCenter, this.controllerPool)
    this.filterController = new MessageFilterController(this.context, this.controllerPool)
  }

  get vuexStore () { return this.context.vuexStore }
  get vuexState () { return this.vuexStore.state }

  get mainStore () { return this.context.mainStore }
  set mainStore (mainStore: MainStore) {
    this.dataCenter.mainStore = mainStore
    this.controllerPool.prepare()
  }

  async init () {
    await this.controllerPool.init()
    await this.unreadCounts.init()
    await this.filterController.init()

    this.initialized = true
  }

  cleanup () {
    this.initialized = false
    this._activeChannels = []
    this.filterController?.cleanup()
    this.unreadCounts?.cleanup()
    this.controllerPool?.cleanup()
    // this.context.cleanup()
    // this.context?.cleanup()
    // this.dataCenter?.cleanup()
  }

  get privateChatRoomContexts () {
    return this.dataCenter.privateChatRooms.map((i) => this.chatRoomContext(i.id)) ?? []
  }

  get homelessChatRoomContexts () {
    return this.controllerPool?.homelessChatRoomContexts
  }

  get helpDeskContexts () {
    return this.dataCenter.helpDeskChatRooms.map((i) => this.chatRoomContext(i.id))
  }

  chatRoom (chatRoomId: number) {
    return this.dataCenter.chatRoom(chatRoomId)
  }

  chatRoomStore (chatRoomId: number) {
    return this.controllerPool.chatRoomStore(chatRoomId)
  }

  chatRoomContext (chatRoomId: number) {
    return this.controllerPool.chatRoomContext(chatRoomId)
  }

  chatRoomController (chatRoomId: number) {
    return this.controllerPool.chatRoomController(chatRoomId)
  }

  helpDeskChatRoomContext (channelId: number, profileId: number) {
    return this.helpDeskContexts.find((i) =>
      i.rootChannelId == channelId &&
      i.participants.some((i) => i.id == profileId),
    )
  }

  _activeChannels: number[] = []

  async initChannelChatRooms (channel: Channel) {
    const mainStore = this.context.mainStore
    if (!mainStore) {
      return
    }
    const userId = mainStore.userId
    const channelId = channel.id
    const isJoined = 0 < userId && mainStore.isJoinedChannelId(channelId)
    if (this._activeChannels.includes(channelId)) {
      return
    }
    if (this._activeChannels.length) {
      const prevChannels = [...this._activeChannels]
      prevChannels.forEach((i) => this.cleanupChannelChatRooms(i))
    }
    this._activeChannels.push(channelId)

    if (isJoined) {
      this.filterController.initChannelFilter(channel)
      await this.dataCenter.initChannelChatRooms(channel)
    }
    await this.controllerPool.initChannelChatRooms(channel)
  }

  cleanupChannelChatRooms (channelId: number) {
    this._activeChannels = this._activeChannels.filter((i) => i != channelId)
    this.controllerPool.cleanupChannelChatRooms(channelId)
    this.dataCenter.cleanupChannelChatRooms(channelId)
  }

}